import { createContext } from "react";
import { createContextualCan } from "@casl/react";
import { AppAbility } from "./ability";

/**
 * React Context for the AppAbility instance.
 *
 * This context provides the current user's permissions (actions and subjects)
 * throughout the app using CASL Ability.
 */
export const AbilityContext = createContext<AppAbility>(undefined!);

/**
 * Default export: Contextual Can component from CASL React.
 *
 * Provides a way to check user permissions declaratively inside JSX.
 * Example usage:
 * ```tsx
 * <Can I="view" a="Client">
 *    <Button>View Client</Button>
 * </Can>
 * ```
 */
export default createContextualCan(AbilityContext.Consumer);
